module.exports = function() {
  return new Worker(__webpack_public_path__ + "f1491f1ef759b9c50f50.worker.js");
};


// WEBPACK FOOTER //
// src/models/Telemetry.worker.js